module.exports = __webpack_public_path__ + "static/media/clock.86e6a376.svg";